module.exports = __webpack_public_path__ + "media/images/lp/industries/bg_polygon-58595b926c0202cf417166ba6e169b81.svg";